'use strict';

var React = require('react');

module.exports = function toArray(children) {
  var ret = [];
  React.Children.forEach(children, function (c) {
    ret.push(c);
  });
  return ret;
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-tree-select/~/rc-util/lib/Children/toArray.js
 ** module id = 644
 ** module chunks = 0 1
 **/